import ActionLink from 'components/action-link/action-link.component';
import styled from 'styled-components';

export const StyledActionLink = styled(ActionLink)`
  margin-top: 1em;
  font-size: 0.875rem;
`;
